/* Beauty First Wholesale — theme.js */
/* Vanilla JS only. No jQuery, no external libraries. */

document.addEventListener('DOMContentLoaded', function () {
  initStickyHeader();
  initMegaMenu();
  initMobileNav();
  initBrandStrip();
  initProductGallery();
  initVariantPills();
  initQuantity();
  initProductTabs();
  initFilterMobileDrawer();
  initCartCount();
  initRelatedProducts();
  initQuickAdd();
  initQuickAddPanels();
});

/* ── 1. Sticky header ──────────────────────────────────────── */
function initStickyHeader() {
  var header = document.querySelector('.site-header');
  if (!header) return;
  window.addEventListener('scroll', function () {
    header.classList.toggle('header--scrolled', window.scrollY > 50);
  }, { passive: true });
}

/* ── 2. Mega menu ──────────────────────────────────────────── */
function initMegaMenu() {
  var headerWrap = document.querySelector('.header-wrap');
  if (!headerWrap) return;

  var navItems    = headerWrap.querySelectorAll('.nav-item');
  var megaPanels  = headerWrap.querySelectorAll('.mega-menu');
  var navLinks    = headerWrap.querySelectorAll('.nav-link');
  var closeTimer  = null;
  var activeId    = null;

  function isMobile() { return window.innerWidth < 1024; }

  function openPanel(id) {
    clearTimeout(closeTimer);
    megaPanels.forEach(function (p) { p.hidden = true; });
    navLinks.forEach(function (l) {
      l.classList.remove('is-open');
      l.setAttribute('aria-expanded', 'false');
    });
    if (!id) { activeId = null; return; }
    var panel = headerWrap.querySelector('[data-mega-panel="' + id + '"]');
    var link  = headerWrap.querySelector('[data-mega-trigger="' + id + '"]');
    if (panel) { panel.hidden = false; activeId = id; }
    if (link)  { link.classList.add('is-open'); link.setAttribute('aria-expanded', 'true'); }
  }

  function scheduleClose() {
    closeTimer = setTimeout(function () { openPanel(null); }, 120);
  }

  navItems.forEach(function (item) {
    var link = item.querySelector('[data-mega-trigger]');
    if (!link) return;
    var id = link.dataset.megaTrigger;

    item.addEventListener('mouseenter', function () {
      if (!isMobile()) openPanel(id);
    });
    item.addEventListener('mouseleave', function () {
      if (!isMobile()) scheduleClose();
    });
    link.addEventListener('click', function (e) {
      if (isMobile()) {
        e.preventDefault();
        openPanel(activeId === id ? null : id);
      }
    });
  });

  megaPanels.forEach(function (panel) {
    panel.addEventListener('mouseenter', function () { clearTimeout(closeTimer); });
    panel.addEventListener('mouseleave', function () { scheduleClose(); });
  });

  document.addEventListener('click', function (e) {
    if (!headerWrap.contains(e.target)) openPanel(null);
  });
}

/* ── 3. Mobile nav drawer ──────────────────────────────────── */
function initMobileNav() {
  var hamburger = document.querySelector('.hamburger');
  var drawer    = document.querySelector('.mobile-nav');
  var closeBtn  = document.querySelector('.mobile-nav__close');
  var overlay   = document.querySelector('.mobile-nav-overlay');
  if (!hamburger || !drawer) return;

  function openDrawer() {
    drawer.classList.add('is-open');
    if (overlay) overlay.classList.add('is-visible');
    document.body.style.overflow = 'hidden';
    hamburger.setAttribute('aria-expanded', 'true');
    trapFocus(drawer);
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-visible');
    document.body.style.overflow = '';
    hamburger.setAttribute('aria-expanded', 'false');
  }

  hamburger.addEventListener('click', openDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (overlay)  overlay.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });
}

function trapFocus(el) {
  var focusable = el.querySelectorAll(
    'a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])'
  );
  if (!focusable.length) return;
  var first = focusable[0];
  var last  = focusable[focusable.length - 1];
  first.focus();
  el.addEventListener('keydown', function handler(e) {
    if (e.key !== 'Tab') return;
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault(); last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault(); first.focus();
    }
    if (!el.classList.contains('is-open')) el.removeEventListener('keydown', handler);
  });
}

/* ── 4. Brand strip arrows ─────────────────────────────────── */
function initBrandStrip() {
  var strip     = document.querySelector('.brand-strip');
  if (!strip) return;
  var track     = strip.querySelector('.brand-strip__track');
  var leftBtn   = strip.querySelector('.brand-strip__arrow--left');
  var rightBtn  = strip.querySelector('.brand-strip__arrow--right');
  if (!track) return;

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reducedMotion) {
    track.style.animationPlayState = 'paused';
  }

  /* The CSS animation provides auto-scroll. Arrows manually advance scroll
     position by pausing the animation and translating the track. */
  var manualX   = 0;
  var tileStep  = 260; /* tile width + gap */
  var paused    = reducedMotion;

  function pause()  { track.style.animationPlayState = 'paused'; paused = true; }
  function resume() { if (!paused) return; track.style.animationPlayState = 'running'; paused = false; manualX = 0; }

  if (leftBtn) leftBtn.addEventListener('click', function () {
    pause();
    manualX -= tileStep;
    track.style.transform = 'translateX(' + manualX + 'px)';
  });
  if (rightBtn) rightBtn.addEventListener('click', function () {
    pause();
    manualX += tileStep;
    track.style.transform = 'translateX(-' + manualX + 'px)';
  });

  if (!reducedMotion) {
    strip.addEventListener('mouseenter', function () { track.style.animationPlayState = 'paused'; });
    strip.addEventListener('mouseleave', function () {
      if (!paused) track.style.animationPlayState = 'running';
    });
  }
}

/* ── 5. Product image gallery ──────────────────────────────── */
function initProductGallery() {
  var gallery = document.querySelector('.product-gallery');
  if (!gallery) return;
  var mainImg = gallery.querySelector('.product-gallery__main-img');
  var thumbs  = gallery.querySelectorAll('.product-gallery__thumb');

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var src = thumb.dataset.src;
      var alt = thumb.dataset.alt || '';
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
      if (mainImg && src) {
        var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reducedMotion) {
          mainImg.removeAttribute('srcset');
          mainImg.removeAttribute('sizes');
          mainImg.src = src;
          mainImg.alt = alt;
        } else {
          mainImg.style.opacity = '0';
          setTimeout(function () {
            mainImg.removeAttribute('srcset');
            mainImg.removeAttribute('sizes');
            mainImg.src = src;
            mainImg.alt = alt;
            mainImg.style.opacity = '1';
          }, 150);
        }
      }
    });
  });
}

/* ── 6. Product variant pills ──────────────────────────────── */
function initVariantPills() {
  var optionGroups = document.querySelectorAll('.product-option');
  if (!optionGroups.length) return;

  /* These may not exist for logged-out visitors — handled gracefully */
  var variantSelect = document.querySelector('.product-variant-select');
  var variantDataEl = document.querySelector('[data-product-variants]');
  var variants = variantDataEl ? JSON.parse(variantDataEl.textContent) : [];

  function getSelectedOptions() {
    return Array.from(optionGroups).map(function (group) {
      var active = group.querySelector('.product-option__pill.is-active');
      return active ? active.dataset.value : '';
    });
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function updateVariant() {
    if (!variantSelect || !variants.length) return;
    var selected = getSelectedOptions();
    var match = null;
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if (v.options && v.options.every(function (opt, idx) { return opt === selected[idx]; })) {
        match = v; break;
      }
    }
    if (!match) return;

    variantSelect.value = match.id;
    variantSelect.dispatchEvent(new Event('change', { bubbles: true }));

    /* Price */
    var priceEl   = document.querySelector('.product-price__current');
    var compareEl = document.querySelector('.product-price__compare');
    if (priceEl && match.price != null) priceEl.textContent = formatMoney(match.price);
    if (compareEl) {
      if (match.compare_at_price > match.price) {
        compareEl.textContent = formatMoney(match.compare_at_price);
        compareEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
      }
    }

    /* SKU */
    var skuEl = document.querySelector('[data-variant-sku]');
    if (skuEl) skuEl.textContent = match.sku ? 'SKU · ' + match.sku : '';

    /* Barcode */
    var barcodeEl = document.querySelector('[data-variant-barcode]');
    if (barcodeEl) barcodeEl.textContent = match.barcode ? 'Barcode · ' + match.barcode : '';

    /* Stock status */
    var stockEl = document.querySelector('[data-variant-stock]');
    if (stockEl) {
      stockEl.textContent = match.available ? 'In stock' : 'Out of stock';
      stockEl.dataset.available = match.available;
    }

    /* Gallery image */
    if (match.featured_image) {
      var mainImg = document.querySelector('.product-gallery__main-img');
      if (mainImg) {
        var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reducedMotion) {
          mainImg.removeAttribute('srcset');
          mainImg.removeAttribute('sizes');
          mainImg.src = match.featured_image;
        } else {
          mainImg.style.opacity = '0';
          setTimeout(function () {
            mainImg.removeAttribute('srcset');
            mainImg.removeAttribute('sizes');
            mainImg.src = match.featured_image;
            mainImg.style.opacity = '1';
          }, 150);
        }

        /* Keep thumbnail active state in sync with the variant's image, if it's in the strip */
        var thumbs = document.querySelectorAll('.product-gallery__thumb');
        thumbs.forEach(function (t) {
          t.classList.toggle('is-active', t.dataset.src === match.featured_image);
        });
      }
    }

    /* Submit button */
    var submitBtn = document.querySelector('.product-form [type="submit"]');
    if (submitBtn) {
      submitBtn.disabled = !match.available;
      submitBtn.textContent = match.available ? 'Add to Cart' : 'Sold Out';
    }
  }

  optionGroups.forEach(function (group) {
    var pills = group.querySelectorAll('.product-option__pill');
    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        pills.forEach(function (p) { p.classList.remove('is-active'); });
        pill.classList.add('is-active');
        updateVariant();
      });
    });
  });
}

/* ── 7. Product quantity ───────────────────────────────────── */
function initQuantity() {
  document.querySelectorAll('.quantity-wrapper').forEach(function (wrapper) {
    var input    = wrapper.querySelector('.quantity-input');
    var decrease = wrapper.querySelector('[data-action="decrease"]');
    var increase = wrapper.querySelector('[data-action="increase"]');
    if (!input) return;

    var cartLine = wrapper.dataset.cartLine;

    function removeCartLine() {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: parseInt(cartLine, 10), quantity: 0 })
      })
        .then(function () { window.location.reload(); })
        .catch(function () { window.location.reload(); });
    }

    if (decrease) decrease.addEventListener('click', function () {
      var val = parseInt(input.value, 10);
      if (val > 1) {
        input.value = val - 1;
      } else if (cartLine) {
        removeCartLine();
      }
    });
    if (increase) increase.addEventListener('click', function () {
      input.value = parseInt(input.value, 10) + 1;
    });
    input.addEventListener('change', function () {
      var val = parseInt(input.value, 10);
      if (cartLine && val === 0) {
        removeCartLine();
        return;
      }
      if (isNaN(val) || val < 1) input.value = 1;
    });
  });
}

/* ── 8. Product tabs ───────────────────────────────────────── */
function initProductTabs() {
  document.querySelectorAll('.product-tabs').forEach(function (tabs) {
    var tabBtns = tabs.querySelectorAll('.product-tab');
    var panels  = tabs.querySelectorAll('.product-tab-panel');

    tabBtns.forEach(function (btn, i) {
      btn.addEventListener('click', function () {
        tabBtns.forEach(function (b) { b.classList.remove('is-active'); });
        panels.forEach(function (p) { p.hidden = true; });
        btn.classList.add('is-active');
        if (panels[i]) panels[i].hidden = false;
      });
    });
  });
}

/* ── 9. Filter mobile drawer ───────────────────────────────── */
function initFilterMobileDrawer() {
  var toggle  = document.querySelector('.filters-toggle');
  var drawer  = document.querySelector('.filter-drawer');
  var closeBtn = document.querySelector('.filter-drawer__close');
  var overlay = document.querySelector('.filter-drawer-overlay');
  if (!toggle || !drawer) return;

  function open() {
    drawer.classList.add('is-open');
    if (overlay) overlay.classList.add('is-visible');
    document.body.style.overflow = 'hidden';
  }
  function close() {
    drawer.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-visible');
    document.body.style.overflow = '';
  }

  toggle.addEventListener('click', open);
  if (closeBtn) closeBtn.addEventListener('click', close);
  if (overlay)  overlay.addEventListener('click', close);
}

/* ── 10. Cart count ────────────────────────────────────────── */
function initCartCount() {
  var badges = document.querySelectorAll('.cart-count');
  if (!badges.length) return;
  fetch('/cart.json')
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      badges.forEach(function (badge) {
        badge.textContent = cart.item_count;
        badge.style.display = cart.item_count > 0 ? 'inline-flex' : 'none';
      });
    })
    .catch(function () {});
}

/* ── 11. Related products ──────────────────────────────────── */
function initRelatedProducts() {
  var container = document.querySelector('.related-products[data-url]');
  if (!container) return;
  var url = container.dataset.url;
  fetch(url)
    .then(function (r) { return r.text(); })
    .then(function (html) {
      var doc     = new DOMParser().parseFromString(html, 'text/html');
      var content = doc.querySelector('.related-products-inner');
      if (content) container.innerHTML = content.innerHTML;
    })
    .catch(function () {});
}

/* ── 12. Quick add to cart (collection page) ───────────────── */
function initQuickAdd() {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.js-quick-add');
    if (!btn || btn.disabled) return;

    var variantId = btn.dataset.variantId;
    if (!variantId) return;

    var scope = btn.closest('.quick-add, .product-card__footer');
    var qtyInput = scope ? scope.querySelector('.quantity-input') : null;
    var quantity = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

    btn.disabled = true;
    var originalText = btn.textContent;
    btn.textContent = 'Adding...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function () { return fetch('/cart.js'); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var badges = document.querySelectorAll('.cart-count');
        badges.forEach(function (badge) {
          badge.textContent = cart.item_count;
          badge.style.display = cart.item_count > 0 ? 'inline-flex' : 'none';
        });
        btn.textContent = 'Added!';
        if (qtyInput) qtyInput.value = 1;
        setTimeout(function () {
          btn.textContent = originalText;
          btn.disabled = false;
        }, 1500);
      })
      .catch(function () {
        btn.textContent = 'Error';
        setTimeout(function () {
          btn.textContent = originalText;
          btn.disabled = false;
        }, 1500);
      });
  });
}

/* ── 13. Quick add panels — variant select on the grid ─────── */
function initQuickAddPanels() {
  var quickAdds = document.querySelectorAll('.quick-add');
  if (!quickAdds.length) return;

  function closeAllExcept(except) {
    quickAdds.forEach(function (qa) {
      if (qa === except) return;
      var panel = qa.querySelector('.quick-add__panel');
      var toggle = qa.querySelector('.js-quick-add-toggle');
      if (panel) panel.hidden = true;
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    });
  }

  quickAdds.forEach(function (quickAdd) {
    var toggle = quickAdd.querySelector('.js-quick-add-toggle');
    var panel  = quickAdd.querySelector('.quick-add__panel');
    if (!toggle || !panel) return;

    toggle.addEventListener('click', function () {
      var isOpen = !panel.hidden;
      closeAllExcept(quickAdd);
      panel.hidden = isOpen;
      toggle.setAttribute('aria-expanded', String(!isOpen));
    });

    var dataEl = panel.querySelector('[data-quick-add-variants]');
    var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
    var optionGroups = panel.querySelectorAll('.quick-add__option');
    var addBtn = panel.querySelector('.js-quick-add');
    var priceEl = quickAdd.closest('.product-card').querySelector('[data-card-price]');

    function getSelectedOptions() {
      return Array.from(optionGroups).map(function (group) {
        var active = group.querySelector('.quick-add__pill.is-active');
        return active ? active.dataset.value : '';
      });
    }

    function formatMoney(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function updateMatch() {
      if (!variants.length || !addBtn) return;
      var selected = getSelectedOptions();
      var match = null;
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        if (v.options && v.options.every(function (opt, idx) { return opt === selected[idx]; })) {
          match = v; break;
        }
      }
      if (!match) return;

      addBtn.dataset.variantId = match.id;
      addBtn.disabled = !match.available;
      addBtn.textContent = match.available ? 'Add to Cart' : 'Sold Out';
      if (priceEl && match.price != null) priceEl.textContent = formatMoney(match.price);
    }

    optionGroups.forEach(function (group) {
      var pills = group.querySelectorAll('.quick-add__pill');
      pills.forEach(function (pill) {
        pill.addEventListener('click', function () {
          if (pill.classList.contains('is-unavailable')) return;
          pills.forEach(function (p) { p.classList.remove('is-active'); });
          pill.classList.add('is-active');
          updateMatch();
        });
      });
    });
  });

  document.addEventListener('click', function (e) {
    if (e.target.closest('.quick-add')) return;
    closeAllExcept(null);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAllExcept(null);
  });
}
